module.exports = __webpack_public_path__ + "static/media/service-img-02.99639e5f.png";